// Announcement Bar + Product Counter Sync
// -----------------------------
// Live Counter Sync
// -----------------------------

window.liveCounterData = window.liveCounterData || {
  viewing: 34,
  purchased: 47
};

function fluctuate(value, min, max, step = 3) {
  const change = Math.floor(Math.random() * step) + 1;
  const direction = Math.random() > 0.5 ? 1 : -1;

  value += change * direction;

  if (value < min) value = min;
  if (value > max) value = max;

  return value;
}

function updateSliderCounters() {

  document.querySelectorAll(".block__slide-item").forEach(function(slide){

    const span = slide.querySelector("span");
    if (!span) return;

    if (span.textContent.trim() === "bought today") {
      slide.innerHTML =
        '<div class="slide-dot"></div>' +
        window.liveCounterData.purchased +
        ' people <span>bought today</span>';
    }

    if (span.textContent.trim() === "right now") {
      slide.innerHTML =
        '<div class="slide-dot"></div>' +
        window.liveCounterData.viewing +
        ' viewing <span>right now</span>';
    }
  });

}

function updateProductCounters() {

  document.querySelectorAll(".live-view-counter").forEach(function(counter){

    const viewing = counter.querySelector(".viewing-count");
    const purchased = counter.querySelector(".purchased-count");

    if(viewing){
      viewing.textContent = window.liveCounterData.viewing;
    }

    if(purchased){
      purchased.textContent = window.liveCounterData.purchased;
    }

  });

}

function updateHeaderCounter(){

  document.querySelectorAll(".header-counter-text").forEach(function(el){
    el.textContent = window.liveCounterData.purchased + " bought today";
  });

}

function updateLiveNumbers(){

  let minViewing = 5;
  let maxViewing = 60;

  const counter = document.querySelector(".live-view-counter");

  if(counter){

    minViewing = parseInt(counter.dataset.min) || minViewing;
    maxViewing = parseInt(counter.dataset.max) || maxViewing;

  }

  // Generate ONE set of values
  window.liveCounterData.viewing = fluctuate(
    window.liveCounterData.viewing,
    minViewing,
    maxViewing
  );

  window.liveCounterData.purchased = fluctuate(
    window.liveCounterData.purchased,
    10,
    120
  );

  // Update every location
  updateProductCounters();
  updateHeaderCounter();
  updateSliderCounters();

}

function initLiveCounter(){

  updateLiveNumbers();

  setInterval(updateLiveNumbers, 300000); // 5 minutes

}

document.addEventListener("DOMContentLoaded", initLiveCounter);

document.addEventListener("shopify:section:load", function(){
  updateLiveNumbers();
});





// Global time
// Global Countdown
(function () {
  const STORAGE_KEY = "global_countdown_end_time";
  const DURATION = 2 * 60 * 60 * 1000; // 2 hours

  function resetEndTime() {
    const endTime = Date.now() + DURATION;
    localStorage.setItem(STORAGE_KEY, endTime);
    return endTime;
  }

  function getEndTime() {
    let endTime = parseInt(localStorage.getItem(STORAGE_KEY), 10);

    if (!endTime || endTime <= Date.now()) {
      endTime = resetEndTime();
    }

    return endTime;
  }

  window.globalCountdown = {
    getEndTime,
    resetEndTime
  };
})();


// Announcementbar script
document.addEventListener("DOMContentLoaded", function () {

  const bar = document.querySelector(".utility-bar");
  const closeBtn = document.querySelector(".announcement-close");
  const announcementTimer = document.querySelector(".announcement-timer");
  const productTimer = document.querySelector("#timer");

  let endTime = window.globalCountdown.getEndTime();

  function updateTimer() {

    let timeLeft = endTime - Date.now();

    if (timeLeft <= 0) {
      endTime = window.globalCountdown.resetEndTime();
      timeLeft = endTime - Date.now();
    }

    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    const formattedTime =
      `${String(hours).padStart(2, "0")}:` +
      `${String(minutes).padStart(2, "0")}:` +
      `${String(seconds).padStart(2, "0")}`;

    if (announcementTimer) {
      announcementTimer.textContent = formattedTime;
    }

    if (productTimer) {
      productTimer.textContent = formattedTime;
    }
  }

  updateTimer();
  setInterval(updateTimer, 1000);

  closeBtn?.addEventListener("click", function () {
    if (bar) bar.style.display = "none";
  });

});(function () {

  const totalSecs = 2 * 3600;

  let endTime = window.globalCountdown.getEndTime();

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function tick() {

    let remaining = Math.floor((endTime - Date.now()) / 1000);

    if (remaining <= 0) {
      endTime = window.globalCountdown.resetEndTime();
      remaining = totalSecs;
    }

    const h = Math.floor(remaining / 3600);
    const m = Math.floor((remaining % 3600) / 60);
    const s = remaining % 60;

    const time = `${pad(h)}:${pad(m)}:${pad(s)}`;

    const hEl = document.getElementById("hrs");
    const mEl = document.getElementById("mins");
    const sEl = document.getElementById("secs");

    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);

    const barEl = document.getElementById("timerBar");

    if (barEl) {
      barEl.style.width = (remaining / totalSecs) * 100 + "%";
    }

    const offerEl = document.getElementById("offerTime");

    if (offerEl) {
      offerEl.textContent = time;
    }

    const stickyEl = document.getElementById("stickyTimerDisplay");

    if (stickyEl) {
      stickyEl.textContent = time;
    }

    const dscTimerEl = document.getElementById("dscTimer");

    if (dscTimerEl) {
      dscTimerEl.textContent = time;
    }

  }

  tick();
  setInterval(tick, 1000);

})();


// Sticky bar spot number
  (function () {

  const SPOTS_KEY = "dsc_spots_value";
  const MIN = 300;   // adjust if you want
  const MAX = 400;

  function getInitialSpots() {
    let val = localStorage.getItem(SPOTS_KEY);

    if (!val) {
      val = Math.floor(Math.random() * (MAX - MIN + 1)) + MIN;
      localStorage.setItem(SPOTS_KEY, val);
    }

    return parseInt(val, 10);
  }

  let spots = getInitialSpots();

  function updateSpots() {
    // change by -20 to +20
    const change = Math.floor(Math.random() * 11) - 5;

    spots += change;

    // keep within range
    if (spots < MIN) spots = MIN;
    if (spots > MAX) spots = MAX;

    localStorage.setItem(SPOTS_KEY, spots);

    const el = document.getElementById("dscSpots");
    if (el) el.textContent = spots;
  }

  // initial render
  updateSpots();

  // update every 60 seconds
  setInterval(updateSpots, 60 * 1000);

})();